import {
  Component,
  ElementRef,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import {
  FileType,
  RFQStatus,
  FileTypeLabel,
  UserType,
  TemplateType,
} from 'src/app/shared/constants/constants';
import { CommonService } from 'src/app/services/common-services/common.service';
import { formatBytes, getValidationParseError } from 'src/app/shared/utils';
import { ConfirmationBoxComponent } from 'src/app/shared/elements/confirmation-box/confirmation-box.component';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { isEmpty, last } from 'lodash';
import { MatStepper } from '@angular/material/stepper';
import { MatDialog } from '@angular/material/dialog';

export type OthersInputType = 'material' | 'category';
export interface OtherValueStatePayload {
  key: OthersInputType;
  value: string;
}

enum TemplateTypeDropdown {
  CapEx = 'CapEx',
  Component = 'Component',
  Dealership = 'Dealership',
  Logistics = 'Logistics',
  Paint = 'Paint',
  Others = 'Others',
  RawMaterial = 'Raw Material',
  Refrigeration = 'Refrigeration',
  // CommercialRefrigeration = 'Commercial Refrigeration',
  Tooling = 'Tooling',
}

@Component({
  selector: 'app-create-rfq',
  templateUrl: './create-rfq.component.html',
  styleUrls: ['./create-rfq.component.scss'],
})
export class CreateRfqComponent implements OnInit, OnChanges {
  @ViewChild('fileSelector') fileSelector!: ElementRef;
  @ViewChild('fileSelectorMultiple') fileSelectorMultiple!: ElementRef;
  @ViewChild('fileSelector2DMultiple') fileSelector2DMultiple!: ElementRef;
  @ViewChild('fileSelectorVideo') fileSelectorVideo!: ElementRef;
  @ViewChild('fileSelectorTNC') fileSelectorTNC!: ElementRef;
  @ViewChild('fileDropRef', { static: false }) fileDropEl:
    | ElementRef
    | undefined;
  @ViewChild('fileDrop2D', { static: false }) fileDrop2D:
    | ElementRef
    | undefined;
  @ViewChild('fileDrop3D', { static: false }) fileDrop3D:
    | ElementRef
    | undefined;
  @ViewChild('fileTNC', { static: false }) fileTNC: ElementRef | undefined;
  @ViewChild('stepper') stepper!: MatStepper;
  @ViewChild('fileDropVideo', { static: false }) fileDropVideo:
    | ElementRef
    | undefined;
  files: any[] = [];
  Multiple2DFile: any[] = [];
  MultipleVideoFile: any[] = [];
  TNCfile: any[] = [];
  SingleFile!: File;
  rfqItem: any;
  rfqAttachments: any = [];
  templateType = TemplateType;
  //attachments: any[] = [];
  threeDAttachments: any = [];
  twoDAttachments: any = [];
  tncAttachment: any = [];
  vidAttachements: any = [];
  baseUrl = environment.BASE_URL;
  customerName: any;
  createRfq!: FormGroup;
  popupShow: boolean = false;
  materialPopupShow: boolean = false;
  userid: string = '';
  companyId: string = '';
  userName: string = '';
  materialData: any;
  categoryData: any;
  categoriesData: any;
  OriginalcategoriesData: any;
  isRfqCreated: boolean = false;
  secondaryProcessData: any[] = [];
  selectedSecondaryProcessList: any[] = [];
  rfqId: any = '';
  selectedOption: string = '';
  isHide: boolean = false;
  isSkipnow: boolean = false;
  is3DMandatory: boolean = false;
  is3DFileUploaded: boolean = false;
  is2DFileUploaded: boolean = false;
  isTNCFileUploaded: boolean = false;
  is2DMandatory: boolean = false;
  selectedCategories: any[] = [];
  blankFile!: File;
  myForm: FormGroup;
  fileLength: any;
  validationStatus: boolean = false;
  errorMessage: string = '';
  invalidFile: boolean = false;
  update_rfqId: any = '';
  rfqDetailData: any;
  alreadySelectedCategories: any;
  alreadySelectedSubCategories: any;
  alreadyMaterials: any;
  documentInfo: any = {
    userType: UserType.Customer,
    documentUseFor: FileType.TNC,
    baseUrl: this.baseUrl,
  };
  resetFileUpload = false;
  fileUploadConfig: any = {
    uploadLabel: 'Upload File',
    buttonName: 'Choose File',
    dragDropText: 'Drag & Drop File or',
    maxFileText: '(Max file size: 100MB)',
    isMultiple: false,
    fileSizeLimit: 10485760, // 10 mb in bytes
    //  fileLocation: `Customer/tnc/${this.rfqId}/${this.createRfq.value.rfqTemplate}`,
    fileFormats:
      '.jpeg, .jpg, .png, .pdf, .doc, .docx, .zip, .dwg, .dxf, .dgn, .stl , .JPEG, .JPG, .PNG, .PDF, .DOC, .DOCX, .ZIP, .DWG, .DXF, .DGN, .STL', // supported file formats for file picker
  };
  rfqTemplateType = '';
  VALID_DRAWING_FILE_EXTS = [
    'jpg',
    'jpeg',
    'png',
    'pdf',
    'doc',
    'docx',
    'zip',
    'dwg',
    'dxf',
    'dgn',
    'stl',
    'step',
    'iges',
    'stp',
    'JPEG',
    'JPG',
    'PNG',
    'PDF',
    'DOC',
    'DOCX',
    'ZIP',
    'DWG',
    'DXF',
    'DGN',
    'STL',
    'STEP',
    'IGES',
    'STP',
  ];

  isOther: boolean = false;
  isRemainingOther: boolean = false;
  isRefrigeration: boolean = false;
  isVideoSelection: boolean = false;
  templateTypeDropdownOptions = Object.keys(TemplateTypeDropdown).map(
    (key) => ({
      value: TemplateTypeDropdown[key as keyof typeof TemplateTypeDropdown],
      label: key,
    })
  );
  errorText: string = '';
  customerCountryName: string = '';
  paymentTermData: any;
  incotermLists: any;
  regionName: any;
  isPaymentRemarksVisible: boolean = false;

  othersInputData: Record<OthersInputType, string> = {
    category: '',
    material: '',
  };

  handleOthersInputData(item: { key: OthersInputType; value: string }) {
    this.othersInputData[item.key as OthersInputType] = item.value;
  }
  currencyData: any;

  constructor(
    private rfqData: CommonService,
    private toastr: ToastrService,
    private commonService: CommonService,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    public dialog: MatDialog
  ) {
    this.userid = localStorage.getItem('customeruserId') || '';
    this.companyId = localStorage.getItem('customercompanyId') || '';
    this.myForm = this.fb.group({
      rfqTemplate: [''],
    });

    this.route.params.subscribe((data: any) => {
      if (!isEmpty(data['id'])) {
        this.update_rfqId = data['id'];
      }
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.fileUploadConfig = {
      uploadLabel: 'Upload File',
      buttonName: 'Choose File',
      dragDropText: 'Drag & Drop File or',
      maxFileText: '(Max file size: 100MB)',
      isMultiple: false,
      fileSizeLimit: 10485760, // 10 mb in bytes
      fileLocation: `Customer/tnc/${this.rfqId}/${this.createRfq.value.rfqTemplate}`,
      fileFormats: '.pdf', // supported file formats for file picker
    };
  }

  ngOnInit(): void {
    this.createRfqForm();
    this.getSecondaryProcess();
    this.getCurrencyData();
    this.getCustomerName();
    this.getCategory();
    this.getMaterial();
    this.paymentTerm();
    this.getincoTerm();
    if (this.update_rfqId != 'add' && this.update_rfqId) {
      this.getRfqDetails();
    }
    this.route.queryParams.subscribe((params: any) => {
      if (params?.template) {
        this.createRfq.controls['rfqTemplate'].setValue(params.template);
        this.rfqTemplateType = params.template;
        this.onFileSelected();
      }
    });
  }

  getSecondaryProcess() {
    this.rfqData
      .getData(`${this.baseUrl}common-service/secondary-process`)
      .subscribe((res) => {
        this.secondaryProcessData = res?.response;
      });
  }

  createRfqForm() {
    this.createRfq = new FormGroup({
      projectName: new FormControl('', Validators.required),
      productName: new FormControl('', Validators.required),
      billingAddress: new FormControl('', Validators.required),
      installationAddress: new FormControl(''),
      totalOrderValue: new FormControl(''),
      rfqSubmissionDate: new FormControl(''),
      toolDeliveryDate: new FormControl(''),
      rfqCurrency: new FormControl('USD', Validators.required),
      projectLife: new FormControl('', Validators.required),
      logisticRequired: new FormControl(false, Validators.required),
      requiredQuotation: new FormControl('', Validators.required),
      serviceSupport: new FormControl(''),
      otherRFQType: new FormControl(''),
      secondaryProcesses: new FormControl([]),
      rfqTemplate: new FormControl('', Validators.required),
      existingProject: new FormControl('', Validators.required),
      otherTemplateType: new FormControl(''),
      paymentTerm: new FormControl('', Validators.required),
      paymentTermRemarks: new FormControl(''),
      incoTerm: new FormControl('', Validators.required),
      minimumOrderQuantity: new FormControl('', Validators.required),
      address: new FormControl('', Validators.required),
      deliveryDate: new FormControl('', Validators.required),
    });
  }

  getSelectedsecondaryProcessList() {
    let selectedSecondryProcess = this.createRfq.value.secondaryProcesses;
    this.secondaryProcessData.forEach((item: any) => {
      item.subSecondaryProcess.forEach((val: any) => {
        if (selectedSecondryProcess) {
          selectedSecondryProcess.forEach((x: any) => {
            if (x == val.subSecondaryProcessId) {
              let obj = {
                id: [x][0],
                name: val.subSecondaryProcessName,
              };
              this.selectedSecondaryProcessList.push(obj);
            }
          });
        }
      });
    });
  }
  temp: any;
  sendRfq() {
    this.getSelectedsecondaryProcessList();
    if (this.rfqDetailData?.adminRFQstatus == RFQStatus.RFQ_RETURNED) {
      this.createRfq.get('rfqTemplate')?.enable();
    }
    const payload = {
      customerId: Number(this.companyId),
      customerName: this.customerName,
      customerRfqMetaData: {
        installationAddress: this.createRfq.value.installationAddress,
        billingAddress: this.createRfq.value.billingAddress,
        logisticsRequired: this.createRfq.value.logisticRequired,
        requiredQuotation: this.createRfq.value.requiredQuotation,
        totalOrderValue: this.createRfq.value.totalOrderValue,
        rfqSubmissionClosingDate: this.createRfq.value.rfqSubmissionDate,
        toolDeliverDate: this.createRfq.value.toolDeliveryDate,
        expectedDateOfDelivery: this.createRfq.value.deliveryDate,
        rfqCurrency: this.createRfq.value.rfqCurrency,
        projectLife: this.createRfq.value.projectLife,
      },
      serviceSupport: this.createRfq.value.serviceSupport,
      projectName: this.createRfq.value.projectName,
      rfqTemplate: [this.createRfq.value.rfqTemplate],
      secondaryProcess: this.selectedSecondaryProcessList.map((obj) => {
        obj.subsecondaryProcess = JSON.stringify(obj.subsecondaryProcess);
        return obj;
      }),
      materialOthers: this.othersInputData.material,
      categoryOthers: this.othersInputData['category'],
      material: this.selectedMaterials,
      category: this.selectedCategories,
      existingProject: this.createRfq.value.existingProject,
      rfqId: this.rfqId,
      othersText: this.createRfq.value.otherRFQType || '',
      otherTemplateType: this.createRfq.value.otherTemplateType || '',
      createdSource: 'portal',
      countryName: this.customerCountryName,
      paymentTerm: this.createRfq.value.paymentTerm,
      paymentTermRemarks: this.createRfq.value.paymentTermRemarks,
      incoTerm: this.createRfq.value.incoTerm,
      address: this.createRfq.value.address,
      moq: this.createRfq.value.minimumOrderQuantity,
      deliveryDate: this.createRfq.value.deliveryDate,
      regionName: this.regionName,
      typesOfDevelopment: this.createRfq.value.existingProject,
    };

    if ((this.update_rfqId != 'add' && this.update_rfqId) || this.rfqId) {
      payload.rfqId = this.rfqDetailData?.id || this.rfqId;
      const apiURL = `${this.baseUrl}rfq/customer/${payload.rfqId}`;
      this.rfqData.update(apiURL, '', payload).subscribe({
        next: (res: any) => {
          this.rfqId = res.response;
          //  this.toastr.success("Profile updated successfully");
          this.isRfqCreated = true;
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error(error.error.status.error.message);
        },
      });
    } else {
      const apiURL = `${this.baseUrl}rfq/customer`;
      this.rfqData.postDatawithoutHeaders(apiURL, payload).subscribe({
        next: (res: any) => {
          this.rfqId = res.response;
          //  this.toastr.success("Profile updated successfully");
          this.isRfqCreated = true;
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error(error.error.status.error.message);
        },
      });
    }
    this.temp = this.createRfq.value.rfqTemplate;
  }

  showCategory() {
    if (this.materialPopupShow) {
      this.materialPopupShow = false;
    }
    this.popupShow = true;
  }
  hidePopup() {
    this.popupShow = false;
  }

  getRfqDetails() {
    this.commonService
      .getData(`${this.baseUrl}rfq/customer/rfq/get/${this.update_rfqId}`)
      .subscribe((res) => {
        this.rfqDetailData = res?.response;
        this.rfqId = this.rfqDetailData?.id;
        this.setForm(this.rfqDetailData);
      });
  }

  tncfileUploadEvent(event: any) {
    this.tncAttachment = [];
    for (const item of event.attachment) {
      this.tncAttachment.push(item);
    }
  }

  setForm(rfqDetailData: any) {
    this.alreadySelectedCategories = rfqDetailData?.category;
    this.alreadySelectedSubCategories = rfqDetailData?.subCategory;
    this.alreadyMaterials = rfqDetailData?.materials;
    this.createRfq.patchValue({
      projectName: rfqDetailData?.projectName,
      secondaryProcesses: rfqDetailData?.secondaryProcesses,
      otherRFQType: rfqDetailData?.othersText || '',
      rfqTemplate: rfqDetailData?.rfqTemplate[0],
      existingProject: String(rfqDetailData?.existingProject),
      paymentTerm: rfqDetailData?.paymentTerm,
      incoTerm: rfqDetailData?.incoTerm,
      address: rfqDetailData?.address,
      minimumOrderQuantity: rfqDetailData?.moq,
      deliveryDate: rfqDetailData?.deliveryDate,
      installationAddress: rfqDetailData?.installationAddress,
      rfqCurrency: rfqDetailData?.parentRfqCurrency,
      billingAddress: rfqDetailData?.billingAddress,
      logisticsRequired: rfqDetailData?.logisticRequired,
      requiredQuotation: rfqDetailData?.requiredQuotation,
      totalOrderValue: rfqDetailData?.totalOrderValue,
      typeOfProject: rfqDetailData?.existingProject,
      rfqSubmissionClosingDate: rfqDetailData?.rfqSubmissionDate,
      toolDeliverDate: rfqDetailData?.toolDeliveryDate,
      expectedDateOfDelivery: rfqDetailData?.deliveryDate,
      serviceSupport: rfqDetailData?.serviceSupport,
    });
    if (rfqDetailData?.adminRFQstatus == RFQStatus.RFQ_RETURNED) {
      this.createRfq.get('rfqTemplate')?.disable();
    }

    let sp: any[] = [];
    rfqDetailData?.secondaryProcesses.forEach((element: any) => {
      sp.push(element?.id);
      this.createRfq.patchValue({
        secondaryProcesses: sp,
      });
    });

    this.setCategory(rfqDetailData);
    this.onFileSelected();
  }

  setCategory(rfqDetailData: any) {
    if (this.alreadySelectedCategories) {
      this.alreadySelectedCategories?.forEach((element: any) => {
        this.selectedCategories.push({
          id: element?.id,
          name: element?.name,
        });
      });
    }

    if (this.alreadySelectedSubCategories) {
      this.alreadySelectedSubCategories?.forEach((element: any) => {
        this.selectedCategories.push({
          id: element?.id,
          name: element?.name,
        });
      });
    }

    if (this.alreadyMaterials) {
      this.alreadyMaterials?.forEach((element: any) => {
        this.selectedMaterials.push({
          id: element?.id,
          name: element?.name,
        });
      });
    }

    rfqDetailData?.attachments?.forEach((element: any) => {
      let apiUrl: string = `${this.baseUrl}auth-service/file-management?id=${element?.id}`;
      this.commonService.getData(apiUrl).subscribe({
        next: (data: any) => {
          this.http
            .get(data.response, { responseType: 'blob' })
            .subscribe((bloB: Blob) => {
              const b: any = bloB;
              b.lastModifiedDate = new Date();
              b.name = element?.fileName;

              if (element?.fileType == 'RFQ') {
                this.SingleFile = <File>bloB;
                this.setFiles('RFQ', element?.id, <File>bloB);
              } else if (element?.fileType == 'Drawing_3D') {
                this.files.push(<File>bloB);
                this.setFiles('Drawing_3D', element?.id, <File>bloB);
              } else if (element?.fileType == 'Drawing_2D') {
                this.Multiple2DFile.push(<File>bloB);
                this.setFiles('Drawing_2D', element?.id, <File>bloB);
              }
            });
        },
      });
    });
  }
  formatBytes(size: number): string {
    return formatBytes(size);
  }

  setFiles(fileType: string, id: string, file: File) {
    if (fileType == 'RFQ') {
      const attachment = {
        id: id,
        type:
          '.' +
          this.SingleFile.name.substring(
            this.SingleFile.name.lastIndexOf('.') + 1
          ), // File type,
        rfqTemplate: this.createRfq.value.rfqTemplate, //tooling component capex
        fileName: this.SingleFile.name,
        fileType: FileType.RFQ,
        size: formatBytes(this.SingleFile.size),
      };
      this.rfqAttachments.push(attachment);
      this.validationStatus = true;
    } else if (fileType == 'Drawing_3D') {
      this.is3DFileUploaded = true;
      const attachment = {
        id: id,
        type: '.' + file.name.substring(file.name.lastIndexOf('.') + 1), //file.type,
        rfqTemplate: this.createRfq.value.rfqTemplate, //tooling component capex
        fileName: file.name,
        fileType: FileType.Drawing_3D, // "Drawing_3D",
        size: formatBytes(file.size),
      };
      //  this.attachments.push(attachment);
      this.threeDAttachments.push(attachment);
    } else if (fileType == 'Drawing_2D') {
      this.is2DFileUploaded = true;
      const attachment = {
        id: id,
        type: '.' + file.name.substring(file.name.lastIndexOf('.') + 1), // file.type,
        rfqTemplate: this.createRfq.value.rfqTemplate, //tooling component capex
        fileName: file.name,
        fileType: FileType.Drawing_2D, //"Drawing_2D",
        size: formatBytes(file.size),
      };

      this.twoDAttachments.push(attachment);
    }
  }

  showMaterial() {
    if (this.popupShow) {
      this.popupShow = false;
    }
    this.materialPopupShow = true;
  }
  hideMaterial() {
    this.materialPopupShow = false;
  }
  selectedMaterials: any[] = [];

  receiveMaterialChild(data: any) {
    this.selectedMaterials = [];
    this.alreadyMaterials = [];
    this.materialData = data;

    if (this.materialData?.length > 0)
      this.materialData.forEach((item: any) => {
        if (
          item.isChecked &&
          !this.selectedMaterials.filter((x: any) => x.id == item.id).length
        )
          this.selectedMaterials.push({ name: item.name, id: item.id });
      });
  }
  receiveCategoryChild(data: any) {
    this.selectedCategories = [];
    this.alreadySelectedSubCategories = [];
    this.alreadySelectedCategories = [];
    this.categoriesData = data;

    if (this.categoriesData.length > 0) {
      const selectedCategoryIds: Set<any> = new Set();

      this.categoriesData.forEach((item: any) => {
        if (item.isChecked) {
          // Check the parent category as well
          if (item.parentCategoryId) {
            const parentCategory = this.categoriesData.find(
              (x: { id: any }) => x.id === item.parentCategoryId
            );
            if (parentCategory && !selectedCategoryIds.has(parentCategory.id)) {
              selectedCategoryIds.add(parentCategory.id);
              this.selectedCategories.push({
                id: parentCategory.id,
                name: parentCategory.name,
              });
            }
          }
          // Always add the current category
          if (!selectedCategoryIds.has(item.id)) {
            selectedCategoryIds.add(item.id);
            this.selectedCategories.push({ id: item.id, name: item.name });

            // Check and add selected subcategories
            if (item.sub && item.sub.length > 0) {
              item.sub.forEach((subCategory: any) => {
                if (
                  subCategory.isChecked &&
                  !selectedCategoryIds.has(subCategory.id)
                ) {
                  selectedCategoryIds.add(subCategory.id);
                  this.selectedCategories.push({
                    id: subCategory.id,
                    name: subCategory.name,
                  });
                }
              });
            }
          }
        }
      });
    }
  }

  getMaterial() {
    this.commonService.getData(`${this.baseUrl}rfq`).subscribe((res) => {
      this.materialData = res.response.find(
        (item: any) => item.name == 'Material'
      ).sub;
      if (this.materialData) {
        this.materialData.forEach((item: any) => {
          item['isChecked'] = false;
        });
      }
    });
  }
  getCurrencyData() {
    this.commonService
      .getData(`${this.baseUrl}common-service/currency`)
      .subscribe((res) => {
        this.currencyData = res?.response;
      });
  }

  paymentTerm() {
    let apiURL = `${this.baseUrl}common-service/payment-term?userType=Customer`;
    this.commonService.getData(apiURL).subscribe((res) => {
      this.paymentTermData = res.response;
    });
  }

  getincoTerm() {
    let apiUrl = `${this.baseUrl}common-service/incoterm`;
    this.commonService.getData(apiUrl).subscribe((data: any) => {
      this.incotermLists = data.response;
    });
  }

  chooseFileSingle() {
    if (this?.fileSelector) {
      let el: HTMLElement = this?.fileSelector?.nativeElement;
      el.click();
    }
  }

  chooseFiles() {
    if (this?.fileSelectorMultiple) {
      let el: HTMLElement = this?.fileSelectorMultiple?.nativeElement;
      el.click();
    }
  }
  choose2DFiles() {
    if (this?.fileSelector2DMultiple) {
      let el: HTMLElement = this?.fileSelector2DMultiple?.nativeElement;
      el.click();
    }
  }
  chooseVideoFile() {
    if (this?.fileSelectorVideo) {
      let el: HTMLElement = this?.fileSelectorVideo?.nativeElement;
      el.click();
    }
  }
  deleteFile(index: number) {
    if (this.files[index]?.progress < 100) {
      return;
    }
    this.files.splice(index, 1);
    this.is3DFileUploaded = false;
    this.fileSelectorMultiple.nativeElement.value = '';
  }
  delete2DFile(index: number) {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        heading: 'Confirm delete',
        content: 'Are you sure you want to delete this 2D file?',
        btnConfirm: 'Confirm',
        btnCancel: 'Cancel',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (!result) {
        return;
      } else if (result) {
        if (this.Multiple2DFile[index]?.progress < 100) {
          return;
        }

        this.Multiple2DFile.splice(index, 1);
        if (this.Multiple2DFile.length < 1) {
          this.is2DFileUploaded = false;
        }

        this.fileSelector2DMultiple.nativeElement.value = '';
        this.getFileUploadS3DUrl2DAndUpload('File Deleted Successfully');
      }
    });
  }
  delete3DFile(index: number) {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        heading: 'Confirm delete',
        content: 'Are you sure you want to delete this 3D file?',
        btnConfirm: 'Confirm',
        btnCancel: 'Cancel',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (!result) {
        return;
      } else if (result) {
        if (this.files[index]?.progress < 100) {
          return;
        }
        this.files.splice(index, 1);

        if (this.files.length < 1) {
          this.is3DFileUploaded = false;
        }
        this.fileSelectorMultiple.nativeElement.value = '';
        this.getFileUploadS3UrlAndUpload('File deleted successfully');
      }
    });
  }

  deleteTNCFile(index: number) {
    if (this.TNCfile[index]?.progress < 100) {
      return;
    }
    this.TNCfile.splice(index, 1);

    if (this.TNCfile.length < 1) {
      this.isTNCFileUploaded = false;
    }
    this.fileSelectorTNC.nativeElement.value = '';
  }

  deleteVideoFile(index: number) {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        heading: 'Confirm delete',
        content: 'Are you sure you want to delete this video file?',
        btnConfirm: 'Confirm',
        btnCancel: 'Cancel',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (!result) {
        return;
      } else if (result) {
        if (this.files[index]?.progress < 100) {
          return;
        }
        this.files.splice(index, 1);

        if (this.files.length < 1) {
          this.is3DFileUploaded = false;
        }
        this.fileSelectorVideo.nativeElement.value = '';
        this.getFileUploadS3DUrlVideoAndUpload('File deleted successfully');
      }
    });
  }

  onVideoDropped($event: any) {
    this.prepareVideoFilesList($event);
  }

  prepareVideoFilesList(files: Array<any>) {
    if (files[0].size / (1024 * 1024) > 100) {
      this.toastr.error('File Size Exceeded');
      if (this?.fileDropVideo) {
        this.fileDropVideo.nativeElement.value = '';
      }
      this.fileSelectorVideo.nativeElement.value = '';
      return;
    }

    for (const item of files) {
      if (item?.progress) {
        item.progress = 0;
      }
      this.MultipleVideoFile.push(item);
    }

    if (this?.fileDropVideo) {
      this.fileDropVideo.nativeElement.value = '';
    }
    this.getFileUploadS3DUrlVideoAndUpload('File Uploaded Successfully');
  }

  getFileUploadS3DUrlVideoAndUpload(msg1: any): void {
    this.vidAttachements = [];
    if (this.MultipleVideoFile.length) {
      this.MultipleVideoFile.forEach((file) => {
        const fileNameList = file?.name?.split('.');
        const filesData = {
          fileName: file.name,
          type: file.type,
          size: formatBytes(file.size),
          userType: 'Customer',
          // location: `Customer/Drawing_2D/${this.rfqId}/${this.createRfq.value.rfqTemplate}/${fileNameList[0]}-${file.lastModified}.${fileNameList[1]}`,
          location: `Customer/videos/${this.rfqId}/${this.createRfq.value.rfqTemplate}/${fileNameList[0]}.${fileNameList[1]}`,
          documentUseFor: 'Other-Video',
        };

        this.commonService
          .postDatawithoutHeaders(
            `${this.baseUrl}auth-service/file-management`,
            filesData
          )
          .subscribe({
            next: async (data: any) => {
              // this.is2DFileUploaded = true;s
              const attachment = {
                id: data.response?.id,
                type: '.' + file.name.substring(file.name.lastIndexOf('.') + 1), // file.type,
                rfqTemplate: this.createRfq.value.rfqTemplate, //tooling component capex
                fileName: file.name,
                fileType: FileType.Video, //"Video",
                size: formatBytes(file.size),
              };

              this.vidAttachements.push(attachment);
              // this.fileUploadDoc = data.response;
              let msg = '';
              if (
                this.vidAttachements.length == this.MultipleVideoFile.length
              ) {
                msg = msg1;
              }
              await this.awsBasicUploadSingle(
                data.response.presignedUrl,
                file,
                msg
              );
            },
            error: (error: HttpErrorResponse) => {
              this.toastr.error(error.error.status.error.message);
            },
          });
      });
    }
  }

  onFileDroppedRfq($event: any) {
    this.files = [];
    let eve = {
      target: {
        files: $event,
      },
    };
    this.fileBrowseHandlerSingle(eve);
  }

  onFileDropped($event: any) {
    this.prepareFilesList($event);
  }
  on2DFileDropped($event: any) {
    this.prepare2DFilesList($event);
  }

  fileHandler(files: any) {
    this.fileLength = files.target.files.length <= 0 ? false : true;
    this.prepareFilesList(files?.target?.files);
  }

  file2DHandler(files: any) {
    this.prepare2DFilesList(files?.target?.files);
  }
  videoFileHandler(files: any) {
    this.prepareVideoFilesList(files?.target?.files);
  }
  fileBrowseHandlerSingle(event: any) {
    let files: File[] = event?.target?.files;
    const fileExt = last(files[0].name.split('.')) as string;

    if (!['xlsx', 'xls'].includes(fileExt)) {
      this.toastr.error('Invalid file extension');
      return;
    }
    if (files[0].size / (1024 * 1024) > 100) {
      this.toastr.error('File Size Exceeded');
      if (this?.fileDropEl) {
        this.fileDropEl.nativeElement.value = '';
      }
      this.fileSelector.nativeElement.value = '';
      return;
    }
    this.SingleFile = files[0];
    if (this?.fileDropEl) {
      this.fileDropEl.nativeElement.value = '';
    }

    this.getFileUploadS3UrlAndUploadSingleFile();
  }
  prepareFilesList(files: Array<any>) {
    const fileExt = last(files[0].name.split('.')) as string;

    if (!this.VALID_DRAWING_FILE_EXTS.includes(fileExt)) {
      this.toastr.error('Invalid file extension');
      return;
    }

    if (files[0].size / (1024 * 1024) > 100) {
      this.toastr.error('File Size Exceeded');
      if (this?.fileDrop3D) {
        this.fileDrop3D.nativeElement.value = '';
      }
      this.fileSelectorMultiple.nativeElement.value = '';
      return;
    }
    for (const item of files) {
      if (item?.progress) {
        item.progress = 0;
      }
      this.files.push(item);
    }
    if (this?.fileDrop3D) {
      this.fileDrop3D.nativeElement.value = '';
    }
    this.getFileUploadS3UrlAndUpload('File uploaded successfully');
  }

  getFileUploadS3UrlAndUpload(msg1: any): void {
    this.threeDAttachments = [];
    if (this.files.length) {
      this.files.forEach((file) => {
        const fileNameList = file?.name?.split('.');
        const filesData = {
          fileName: file.name,
          type: file.type,
          size: formatBytes(file.size),
          userType: 'Customer',
          // location: `Customer/Drawing_3D/${this.rfqId}/${this.createRfq.value.rfqTemplate}/${fileNameList[0]}-${file.lastModified}.${fileNameList[1]}`,
          location: `Customer/Drawing_3D/${this.rfqId}/${this.createRfq.value.rfqTemplate}/${fileNameList[0]}.${fileNameList[1]}`,
          documentUseFor: 'Drawing',
        };

        this.commonService
          .postDatawithoutHeaders(
            `${this.baseUrl}auth-service/file-management`,
            filesData
          )
          .subscribe({
            next: async (data: any) => {
              this.is3DFileUploaded = true;
              const attachment = {
                id: data.response.id,
                type: '.' + file.name.substring(file.name.lastIndexOf('.') + 1), //file.type,
                rfqTemplate: this.createRfq.value.rfqTemplate, //tooling component capex
                fileName: file.name,
                fileType: FileType.Drawing_3D, // "Drawing_3D",
                size: formatBytes(file.size),
              };
              //  this.attachments.push(attachment);
              this.threeDAttachments.push(attachment);
              // this.fileUploadDoc = data.response;
              let msg = '';
              if (this.threeDAttachments.length == this.files.length) {
                msg = msg1;
              }

              await this.awsBasicUploadSingle(
                data.response.presignedUrl,
                file,
                msg
              );
            },
            error: (error: HttpErrorResponse) => {
              this.toastr.error(error.error.status.error.message);
            },
          });
      });
    }
  }
  prepare2DFilesList(files: Array<any>) {
    const fileExt = last(files[0].name.split('.')) as string;

    if (!this.VALID_DRAWING_FILE_EXTS.includes(fileExt)) {
      this.toastr.error('Invalid file extension');
      return;
    }
    if (files[0].size / (1024 * 1024) > 100) {
      this.toastr.error('File Size Exceeded');
      if (this?.fileDrop2D) {
        this.fileDrop2D.nativeElement.value = '';
      }
      this.fileSelector2DMultiple.nativeElement.value = '';
      return;
    }

    for (const item of files) {
      if (item?.progress) {
        item.progress = 0;
      }
      this.Multiple2DFile.push(item);
    }
    if (this?.fileDrop2D) {
      this.fileDrop2D.nativeElement.value = '';
    }
    this.getFileUploadS3DUrl2DAndUpload('File uploaded successfully');
  }
  getFileUploadS3DUrl2DAndUpload(msg1: any): void {
    this.twoDAttachments = [];
    if (this.Multiple2DFile.length) {
      this.Multiple2DFile.forEach((file) => {
        const fileNameList = file?.name?.split('.');
        const filesData = {
          fileName: file.name,
          type: file.type,
          size: formatBytes(file.size),
          userType: 'Customer',
          // location: `Customer/Drawing_2D/${this.rfqId}/${this.createRfq.value.rfqTemplate}/${fileNameList[0]}-${file.lastModified}.${fileNameList[1]}`,
          location: `Customer/Drawing_2D/${this.rfqId}/${this.createRfq.value.rfqTemplate}/${fileNameList[0]}.${fileNameList[1]}`,
          documentUseFor: 'Drawing',
        };

        this.commonService
          .postDatawithoutHeaders(
            `${this.baseUrl}auth-service/file-management`,
            filesData
          )
          .subscribe({
            next: async (data: any) => {
              this.is2DFileUploaded = true;
              const attachment = {
                id: data.response?.id,
                type: '.' + file.name.substring(file.name.lastIndexOf('.') + 1), // file.type,
                rfqTemplate: this.createRfq.value.rfqTemplate, //tooling component capex
                fileName: file.name,
                fileType: FileType.Drawing_2D, //"Drawing_2D",
                size: formatBytes(file.size),
              };

              this.twoDAttachments.push(attachment);
              // this.fileUploadDoc = data.response;
              let msg = '';
              if (this.twoDAttachments.length == this.Multiple2DFile.length) {
                msg = msg1;
              }

              await this.awsBasicUploadSingle(
                data.response.presignedUrl,
                file,
                msg
              );
            },
            error: (error: HttpErrorResponse) => {
              this.toastr.error(error.error.status.error.message);
            },
          });
      });
    }
  }

  getFileUploadS3UrlAndUploadSingleFile() {
    this.rfqAttachments = [];
    const fileNameChars = this.SingleFile.name?.split('');
    if (fileNameChars.length > 200) {
      this.rfqAttachments = [];
      this.SingleFile = this.blankFile;
      this.errorMessage = 'File name is too long or more than 200 characters';
      this.fileSelector.nativeElement.value = '';
      this.invalidFile = false;
      return;
    }
    const fileNameList: string[] = this.SingleFile.name?.split('.');
    const fileExt = fileNameList.pop();
    const fileName = fileNameList.join('.');
    const filesData = {
      fileName: this.SingleFile.name,
      type: this.SingleFile.type,
      size: formatBytes(this.SingleFile.size),
      userType: 'Customer',
      // location: `Customer/rfq/${this.rfqId}/${this.createRfq.value.rfqTemplate}/${fileName}-${this.SingleFile.lastModified}.${fileExt}`,
      location: `Customer/rfq/${this.rfqId}/${this.createRfq.value.rfqTemplate}/${fileName}.${fileExt}`,
      documentUseFor: `RFQ`,
    };
    this.http
      .post(`${this.baseUrl}auth-service/file-management`, filesData)
      .subscribe({
        next: async (data: any) => {
          if (data?.status?.responseStatus == 'Failure') {
            this.toastr.error(data?.status?.error?.identifier);
            this.SingleFile = this.blankFile;
            return;
          }
          const attachment = {
            id: data.response?.id,
            type:
              '.' +
              this.SingleFile.name.substring(
                this.SingleFile.name.lastIndexOf('.') + 1
              ), // File type,
            rfqTemplate: this.createRfq.value.rfqTemplate, //tooling component capex
            fileName: this.SingleFile.name,
            fileType: FileType.RFQ,
            size: formatBytes(this.SingleFile.size),
          };
          this.rfqAttachments.push(attachment);

          await this.awsBasicUploadSingle(
            data.response.presignedUrl,
            this.SingleFile,
            'file uploaded successfully',
            filesData,
            data.response?.id
          );
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error(error.error.status.error.message);
        },
      });
  }

  async awsBasicUploadSingle(
    url: string,
    file: File,
    msg: string,
    validateFile?: any,
    fileId?: number
  ) {
    const HttpUploadOptions = {
      headers: new HttpHeaders({ 'Content-Type': file.type }),
    };
    this.http.put(url, file, HttpUploadOptions).subscribe({
      next: (data: any) => {
        // this.fileUploadDoc.fileUploadStatus = true;
        // this.fileUploadEvent.emit(this.fileUploadDoc);
        // if (validateFile && validateFile.location && fileId) {
        //   this.validateRfqFile(
        //     fileId,
        //     validateFile.location,
        //     this.SingleFile.name
        //   );
        // }
        this.validate();
      },
      error: (error: HttpErrorResponse) => {
        // this.fileUploadDoc.fileUploadStatus = false;
        if (error?.error?.status?.error?.message) {
          this.toastr.error(error.error.status.error.message);
        }
      },
    });
  }
  validate() {
    this.validationStatus = true;
  }

  validateRfqFile(id: number, fileLocation: string, fileName: string) {
    let payLoad = {
      fileId: id,
      rfqTemplate: this.createRfq.value.rfqTemplate,
      fileLocation: fileLocation,
    };
    let apiURL = '';
    if (this.update_rfqId != 'add' && this.update_rfqId) {
      apiURL = `${this.baseUrl}rfq/customer/validateCustomerExcelFile/${this.rfqDetailData?.id}`;
    } else {
      apiURL = `${this.baseUrl}rfq/customer/validateCustomerExcelFile/${this.rfqId}`;
    }
    this.commonService.postDatawithoutHeaders(apiURL, payLoad).subscribe({
      next: async (data: any) => {
        if (data?.status?.error?.message) {
          this.errorMessage =
            last(data?.status?.error?.message?.split(':')) || '';
          this.rfqAttachments = [];
          this.SingleFile = this.blankFile;
          this.invalidFile = false;
          this.fileSelector.nativeElement.value = '';
          return;
        }
        this.validationStatus = data?.response?.validationStatus;
        if (!this.validationStatus) {
          let validateMessage = getValidationParseError(
            this.createRfq.controls['rfqTemplate'].value,
            'Template'
          );
          this.rfqAttachments = [];
          this.SingleFile = this.blankFile;
          this.fileSelector.nativeElement.value = '';
          this.downloadUploadedFiles(id, fileName, true);
          //this.errorMessage = `Errors found in ${this.createRfq.value.rfqTemplate} RFQ file, kindly check and upload the file again.`;
          this.errorMessage = validateMessage.heading;
          this.errorText = validateMessage.text;
          this.invalidFile = true;
        } else {
          this.errorMessage = '';
          this.invalidFile = false;
          this.toastr.success('File Uploaded Successfully');
        }
      },
      error: (error: HttpErrorResponse) => {
        this.rfqAttachments = [];
        this.SingleFile = this.blankFile;
        let errorMessage: string =
          last(error.error.status.error.message?.split(':')) ||
          'Something bad happened, please try again later.';
        this.errorMessage = errorMessage;
        this.invalidFile = false;
        this.fileSelector.nativeElement.value = '';
      },
    });
  }

  downloadUploadedFiles(
    id: number,
    fileName: string,
    callDelete: boolean
  ): void {
    const apiUrl: string = `${this.baseUrl}auth-service/file-management?id=${id}`;
    this.commonService.getData(apiUrl).subscribe({
      next: (data: any) => {
        let link = document?.createElement('a');
        link.href = data.response;
        link.download = fileName;
        link.target = '_blank';
        link.click();
        // this.deleteFileFromS3(id);
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(`Error while fetching the file from server`);
      },
    });
  }

  disableSaveAndContinue(): boolean {
    if (!this.validationStatus || this.rfqAttachments.length == 0) {
      return true;
    }
    return false;
  }

  deleteFileFromS3(id: number): void {
    const apiURL = `${this.baseUrl}auth-service/file-management?excelId=${id}`;
    this.commonService.delete(apiURL).subscribe({
      next: (data: any) => {
        console.log(data);
      },
      error: (error: HttpErrorResponse) => {
        this.toastr.error(error.error.status.error.message);
      },
    });
  }

  skipForNow() {
    this.files = [];
    this.Multiple2DFile = [];
    this.twoDAttachments = [];
    this.threeDAttachments = [];
    this.vidAttachements = [];
    this.tncAttachment = [];
  }

  update2D3DRFQFile(): any {
    let apiURL = `${this.baseUrl}rfq/customer/rfq/replacefile/`;
    let attachment = [];
    for (let val of this.twoDAttachments) {
      attachment.push(val);
    }
    for (let val of this.threeDAttachments) {
      attachment.push(val);
    }
    for (let val of this.vidAttachements) {
      attachment.push(val);
    }
    for (let val of this.tncAttachment) {
      attachment.push(val);
    }
    const payLoad = attachment;
    if (this.update_rfqId != 'add' && this.update_rfqId) {
      this.rfqId = this.rfqDetailData?.id;
    }
    if (payLoad.length != 0) {
      this.commonService.update(apiURL, this.rfqId, payLoad).subscribe({
        next: (data: any) => {
          if (this.stepper.selected) {
            this.stepper.selected.completed = true;
          }
          this.nextStep(this.stepper);
        },
        error: (error: HttpErrorResponse) => {
          this.toastr.error(error.error.status.error.message);
        },
      });
    }
  }

  updateRFQFile() {
    let apiURL = `${this.baseUrl}rfq/customer/rfq/replacefile/`;
    const payLoad = this.rfqAttachments;
    if (this.update_rfqId != 'add' && this.update_rfqId) {
      this.rfqId = this.rfqDetailData?.id;
    }
    this.commonService
      .update(apiURL, this.rfqId, payLoad)
      .subscribe((res: any) => {
        // this.rfqAttachments = [];
      });
  }

  UpdateRFQStatus() {
    if (this.update_rfqId != 'add' && this.update_rfqId) {
      this.rfqId = this.rfqDetailData?.id;
    }
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        heading: 'Confirm RFQ Submission',
        content:
          'Please ensure all details are accurate. Are you ready to submit your Request for Quote (RFQ)?',
        btnConfirm: 'Submit RFQ',
        btnCancel: 'Cancel',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (!result) {
        return;
      } else if (result) {
        let apiURL = `${this.baseUrl}rfq/customer/${this.rfqId}/QUOTE_IN_PROGRESS`;
        this.commonService
          .postDatawithoutHeaders(apiURL, {})
          .subscribe((res: any) => {
            if (res.status.responseStatus == 'Success') {
              this.isHide = true;
            } else {
              this.isHide = false;
            }
          });
      }
    });
  }

  navigateToRFQList(): void {
    this.router.navigate(['/rfq']);
  }

  getCustomerName() {
    let apiURL = `${this.baseUrl}customer/company-management/getCompanyDetails?companyId=${this.companyId}`;
    this.commonService.getData(apiURL).subscribe((res) => {
      this.customerName = res.response.name;
      this.regionName = res.response.regionName;
      if (res.response.countryName == null) {
        this.toastr.error('Please update your profile to create RFQ');
      } else {
        this.customerCountryName = res.response.countryName;
      }
    });
  }

  isFirstStepValid() {
    if (
      this.createRfq.controls['projectName'].status === 'INVALID' ||
      this.createRfq.controls['billingAddress'].status === 'INVALID' ||
      (this.isPaymentRemarksVisible &&
        this.createRfq.controls['paymentTermRemarks'].status === 'INVALID') ||
      this.createRfq.controls['rfqTemplate'].status === 'INVALID' ||
      this.createRfq.controls['secondaryProcesses'].value === '' ||
      (this.createRfq.controls['existingProject'].value === '' &&
        !this.isRefrigeration) ||
      (!this.selectedMaterials &&
        !this.isOther &&
        !this.isRemainingOther &&
        !this.isRefrigeration) ||
      !this.selectedCategories ||
      (this.selectedCategories.length == 0 && !this.isRefrigeration) ||
      (this.selectedMaterials.length == 0 &&
        !this.isOther &&
        !this.isRemainingOther &&
        !this.isRefrigeration) ||
      (this.createRfq.controls['otherRFQType'].status === 'INVALID' &&
        (this.isOther || this.isRefrigeration)) ||
      (this.createRfq.controls['rfqTemplate'].value !==
        this.templateType.Tooling &&
        this.createRfq.controls['address'].status === 'INVALID') ||
      this.createRfq.controls['minimumOrderQuantity'].status === 'INVALID' ||
      this.createRfq.controls['paymentTerm'].value === '' ||
      this.createRfq.controls['deliveryDate'].status === 'INVALID' ||
      this.createRfq.controls['incoTerm'].value === '' ||
      (this.createRfq.controls['rfqTemplate'].value == 'Component' &&
        this.createRfq.controls['projectLife'].status === 'INVALID') ||
      this.createRfq.controls['rfqCurrency'].status === 'INVALID' ||
      this.createRfq.controls['productName'].status === 'INVALID'
    ) {
      return true;
    } else {
      return false;
    }
  }

  onFileSelected(): void {
    this.createRfq.controls['otherRFQType'].clearValidators();
    this.createRfq.controls['otherRFQType'].updateValueAndValidity();
    this.isVideoSelection = false;
    this.categoriesData = this.OriginalcategoriesData;

    if (this.update_rfqId != 'add' && this.update_rfqId) {
      this.selectedOption = this.createRfq.controls['rfqTemplate'].value;
    } else {
      this.selectedOption = this.createRfq.value.rfqTemplate;
    }

    if (this.errorMessage) {
      this.errorMessage = '';
    }

    if (this.selectedOption == this.templateType.Refrigeration) {
      this.isRefrigeration = true;
      this.isOther = false;
      this.isRemainingOther = true;
      this.isVideoSelection = true;
      this.is3DMandatory = false;
      this.is2DMandatory = false;
      this.isSkipnow = false;
      this.createRfq.controls['existingProject'].clearValidators();
      this.createRfq.controls['existingProject'].updateValueAndValidity();
    }
    if (['Logistics', 'RawMaterial'].includes(this.selectedOption)) {
      if (this.selectedOption == 'Logistics') {
        this.categoriesData = this.categoriesData.filter((category: any) =>
          ['3 PL', '4 PL', 'Packaging', 'Logistics', 'Warehousing'].includes(
            category.name
          )
        );
      }
      if (this.selectedOption == this.templateType.RawMaterial) {
        this.categoriesData = this.categoriesData.filter((category: any) =>
          ['Copper', 'Paint', 'Resin', 'Steel', 'Aluminium'].includes(
            category.name
          )
        );
      }
      this.isOther = false;
      this.isRefrigeration = false;
      this.isRemainingOther = true;
      this.isVideoSelection = true;
      this.is3DMandatory = false;
      this.is2DMandatory = false;
      this.isSkipnow = false;
      this.createRfq.controls['projectLife'].clearValidators();
      this.createRfq.controls['projectLife'].updateValueAndValidity();
      this.createRfq.controls['productName'].clearValidators();
      this.createRfq.controls['productName'].updateValueAndValidity();
    }
    if (this.selectedOption == this.templateType.Others) {
      this.isOther = true;
      this.isRefrigeration = false;
      this.isVideoSelection = true;
      this.isRemainingOther = false;
      this.is3DMandatory = false;
      this.is2DMandatory = false;
      this.isSkipnow = false;
      this.createRfq.controls['otherRFQType'].setValidators(
        Validators.required
      );
      this.createRfq.controls['otherRFQType'].updateValueAndValidity();
      this.createRfq.controls['projectLife'].clearValidators();
      this.createRfq.controls['projectLife'].updateValueAndValidity();
      this.createRfq.controls['productName'].clearValidators();
      this.createRfq.controls['productName'].updateValueAndValidity();
    }
    if (['Dealership', 'Paint'].includes(this.selectedOption)) {
      this.isOther = false;
      this.isVideoSelection = true;
      this.isRemainingOther = false;
      this.is3DMandatory = false;
      this.is2DMandatory = false;
      this.isSkipnow = false;
      this.createRfq.controls['projectLife'].clearValidators();
      this.createRfq.controls['projectLife'].updateValueAndValidity();
    }
    if (this.selectedOption == this.templateType.Tooling) {
      this.is3DMandatory = true;
      this.isRefrigeration = false;
      this.isRemainingOther = false;
      this.isOther = false;
      this.is2DMandatory = false;
      this.isSkipnow = false;
      this.createRfq.controls['address'].clearValidators();
      this.createRfq.controls['address'].updateValueAndValidity();
      this.createRfq.controls['projectLife'].clearValidators();
      this.createRfq.controls['projectLife'].updateValueAndValidity();
      this.createRfq.controls['productName'].clearValidators();
      this.createRfq.controls['productName'].updateValueAndValidity();
      this.createRfq.controls['requiredQuotation'].clearValidators();
      this.createRfq.controls['requiredQuotation'].updateValueAndValidity();
    }
    if (this.selectedOption == this.templateType.Component) {
      this.is3DMandatory = false;
      this.isRefrigeration = false;
      this.isRemainingOther = false;
      this.isOther = false;
      this.is2DMandatory = true;
      this.isSkipnow = false;
      this.createRfq.controls['productName'].clearValidators();
      this.createRfq.controls['productName'].updateValueAndValidity();
    }
    if (this.selectedOption == this.templateType.CapEx) {
      this.is3DMandatory = false;
      this.isRemainingOther = false;
      this.isOther = false;
      this.is2DMandatory = false;
      this.isSkipnow = true;
      this.createRfq.controls['projectLife'].clearValidators();
      this.createRfq.controls['projectLife'].updateValueAndValidity();
      this.createRfq.controls['productName'].clearValidators();
      this.createRfq.controls['productName'].updateValueAndValidity();
      this.createRfq.controls['requiredQuotation'].clearValidators();
      this.createRfq.controls['requiredQuotation'].updateValueAndValidity();
    }
  }

  downloadFile(fileName: string) {
    if (
      [
        'Logistics',
        'RawMaterial',
        'Others',
        'Dealership',
        'Refrigeration',
        'Paint',
      ].includes(fileName)
    ) {
      fileName = 'Others';
    }
    fileName = fileName + 'Rfq';

    let apiUrl: string = `${this.baseUrl}auth-service/file-management/sample-template?name=${fileName}`;
    this.commonService.getData(apiUrl).subscribe({
      next: (data: any) => {
        let link = document?.createElement('a');
        link.href = data.response;
        link.download = fileName;
        link.target = '_blank';
        link.click();
      },
      error: (error) => {
        this.toastr.error(`Error while fetching the file from server`);
      },
    });
  }

  getFileName(name: string): string {
    let nm = name.substring(0, name.lastIndexOf('.'));
    // return name.split('.')[0];
    return nm;
  }

  getFileExt(name: string): string {
    let extension = name.substring(name.lastIndexOf('.') + 1);
    // return name.split('.')[1];
    return extension;
  }

  getCategory() {
    this.commonService.getData(`${this.baseUrl}rfq`).subscribe((res) => {
      this.categoriesData = res?.response?.find(
        (item: any) => item.name == 'Category'
      ).sub;
      if (this.categoriesData?.length)
        this.categoriesData.forEach((item: any) => {
          item['isChecked'] = false;
          if (item?.sub?.length > 0)
            item.sub.forEach((value: any) => {
              value['isChecked'] = false;
            });
        });

      // All Original Categories since performing filtering on the categoriesData
      this.OriginalcategoriesData = res?.response?.find(
        (item: any) => item.name == 'Category'
      ).sub;
      if (this.categoriesData?.length)
        this.categoriesData.forEach((item: any) => {
          item['isChecked'] = false;
          if (item?.sub?.length > 0)
            item.sub.forEach((value: any) => {
              value['isChecked'] = false;
            });
        });
      // this.initializeChecks(this.categoryData);
    });
  }

  deleteRfq() {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        heading: 'Confirm delete ',
        content: 'Are you sure you want to delete this file ?',
        btnConfirm: 'Confirm',
        btnCancel: 'Cancel',
      },
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (!result) {
        return;
      } else if (result) {
        this.SingleFile = this.blankFile;
        this.rfqAttachments = [];
        this.fileSelector.nativeElement.value = '';
        this.errorMessage = '';
      }
    });
  }

  removeMaterial(id: any) {
    let index = this.selectedMaterials.findIndex((item: any) => item.id == id);

    if (this.selectedMaterials[index].name === 'Others') {
      this.othersInputData['material'] = '';
    }

    this.selectedMaterials.splice(index, 1);
    this.materialData.forEach((value: any) => {
      if (value.id == id) value.isChecked = false;
    });
  }

  removeCategory(id: any) {
    let index = this.selectedCategories.findIndex((item: any) => item.id == id);
    this.selectedCategories.splice(index, 1);
    this.categoriesData.forEach((item: any) => {
      if (item.id == id) {
        item.isChecked = false;
      }
      if (item.sub.length > 0) {
        item.sub.forEach((value: any) => {
          if (value.id == id) {
            value.isChecked = false;
          }

          if (value.name === 'Others') {
            this.othersInputData['category'] = '';
          }
        });
      }
    });
  }

  // selectAll(list:any) {
  //   console.log(list)
  //   const addedProcesses: any = [];
  //   list?.forEach((process:any, index:number)=>{
  //     if(process?.subSecondaryProcessId) {
  //       addedProcesses.push(process?.subSecondaryProcessId);

  //     }
  //      console.log(process.subSecondaryProcessId, "Process Id");
  //      addedProcesses.push(process.subSecondaryProcessId);
  //   });
  //   this.createRfq.controls['secondaryProcesses'].patchValue(addedProcesses);
  //   //this.createRfq.get('secondaryProcesses')?.patchValue(list)
  // }

  nextStep(stepper: MatStepper) {
    stepper.next();
  }

  backStep(stepper: MatStepper) {
    stepper.previous();
  }
  paymentTermChanged(ev: any) {
    const value = ev.value;
    const paymentTermRemarksControl = this.createRfq.get('paymentTermRemarks');
    if (value == 'Custom Terms') {
      paymentTermRemarksControl?.setValidators([Validators.required]);
      this.isPaymentRemarksVisible = true;
    } else {
      paymentTermRemarksControl?.clearValidators();
      this.isPaymentRemarksVisible = false;
      paymentTermRemarksControl?.setValue(null);
    }
  }
}
